// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"acca0757","587":"790f2dc2","607":"7ca73b57"}[chunkId] + ".chunk.js";
};